<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>รหัสวัตถุดิบ</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="text"
                       v-model="material.code"
                       disabled
                />
            </b-col>
        </b-row>
        <br>

        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>ชื่อวัตถุดิบ</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="text"
                       style="text-overflow: ellipsis; "
                       :title="material.name"
                       v-model="material.name"
                       disabled
                />
            </b-col>
        </b-row>
        <!--<b-row sm="10">-->
            <!--<b-col sm="4" class="col text-right">-->
                <!--<label>ราคา</label>-->
            <!--</b-col>-->
            <!--<b-col sm="6">-->
                <!--<input class="form-control"-->
                       <!--type="number"-->
                       <!--v-model="material.price"-->
                       <!--disabled-->
                <!--/>-->
            <!--</b-col>-->
        <!--</b-row>-->
        <br>

        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>สั่งซื้อจำนวน</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="number"
                       v-model="form.quantity"
                />
            </b-col>
            <div class="col">
                <label>{{material.unit}}</label>
            </div>
        </b-row>
        <input type="hidden" v-model="getDateNow"/>
        <br>
        <b-row>
            <div class="col text-center">
                <button @click="onSubmitImport"
                        :disabled="form.onSave"
                        type="button"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>&nbsp&nbsp
                <button @click="cancelModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
        <br>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import moment from "moment";
    import Multiselect from "vue-multiselect";

    export default {
        name: "pre-order-materials",
        components:{Multiselect},
        data() {
            return {
                id: "",
                form: {
                    quantity: "",
                    date: "",
                    vendor:"",
                    onSave: false,
                }
            };
        },
        created() {

        },
        computed: {
            ...mapState({
                user: state => {
                    return state.Auth.user;
                },
                material: state => {
                    return state.Material.replace_data;
                },
                getDateNow(){
                    const currentDate = moment().format("YYYY-MM-DD");
                    this.form.date = currentDate;
                }
            })
        },
        methods: {
            onSubmitImport() {
                if(this.form.quantity < 1){
                    alert('กรุณาใส่จำนวน')
                }
                // else if(!this.form.vendor){
                //     alert('กรุณาเลือกผู้จำหน่าย')
                // }
                else{
                    let data = {
                        material_id : this.material.id,
                        material_code : this.material.code,
                        price : this.material.price,
                        quantity : this.form.quantity,
                        user_id : this.user.id,
                        vendor_id : null,
                        date : this.form.date,
                        status : 1
                    };
                    this.form.onSave = true;
                    this.$emit("submit", data);
                    this.form = {
                        quantity: "",
                        date: "",
                        vendor:"",
                        onSave: false,
                    }
                }
            },
            cancelModal(){
                this.$emit("submit", 0);
                this.form = {
                    quantity: "",
                    date: "",
                    vendor:"",
                    onSave: false,
                }
            },
        }
    };
</script>

<style scoped></style>
